import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AppMaterialModule } from '../../../app-material.module';
import { ThemeService } from '../../services/theme.service';

@Component({
    selector: 'app-theme-switcher',
    standalone: true,
    imports: [CommonModule, AppMaterialModule, TranslocoPipe],
    templateUrl: './theme-switcher.component.html',
    styleUrl: './theme-switcher.component.scss',
})
export class ThemeSwitcherComponent {
    @Input() buttonClass = 'theme-toggle-btn';
    @Input() matIconButton = true;
    @Input() showTooltip = true;
    @Input() lightModeTooltipKey = 'admin.shell.lightMode';
    @Input() darkModeTooltipKey = 'admin.shell.darkMode';

    constructor(public readonly themeService: ThemeService) {}

    public get tooltipKey(): string {
        return this.themeService.isDark() ? this.lightModeTooltipKey : this.darkModeTooltipKey;
    }
}
